import React from "react";
import { ArrowUpRightIcon, EnvelopeIcon } from "@heroicons/react/24/outline";

const contactEmail = "web3infra.io@gmail.com";

const Web3Contact = () => (
  <>
    <section
      id="contact"
      className="border-t border-white/10 bg-white text-black"
    >
      <div className="container-v3 grid gap-10 py-16 md:py-24 lg:grid-cols-[1fr_auto] lg:items-end">
        <div className="max-w-3xl">
          <div className="font-mono text-xs font-bold uppercase text-gray-500">
            Start a conversation
          </div>
          <h2 className="mt-5 text-4xl font-black leading-tight md:text-6xl">
            Build the infrastructure behind your next Web3 product.
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-8 text-gray-600 md:text-lg">
            Tell us what you need to launch, integrate, or scale. We will map
            the right contract, wallet, algorithm, and gateway architecture.
          </p>
        </div>
        <a
          href={`mailto:${contactEmail}`}
          className="inline-flex min-h-14 items-center justify-between gap-5 rounded-lg bg-black px-6 py-4 font-bold text-white"
        >
          <span className="inline-flex items-center gap-3">
            <EnvelopeIcon className="h-5 w-5" /> {contactEmail}
          </span>
          <ArrowUpRightIcon className="h-5 w-5 shrink-0" />
        </a>
      </div>
    </section>
    <footer className="border-t border-white/10 bg-black py-8">
      <div className="container-v3 flex flex-col gap-3 text-sm text-gray-500 sm:flex-row sm:items-center sm:justify-between">
        <span className="font-mono text-gray-300">Web3infra.io</span>
        <a
          href={`mailto:${contactEmail}`}
          className="transition-colors hover:text-white"
        >
          {contactEmail}
        </a>
        <span>Contracts · Wallets · Algorithms · Gateways</span>
      </div>
    </footer>
  </>
);

export default Web3Contact;
